import { CART_PRODUCTS_DOMAIN } from 'modules/cart-products/constants'
import { getInstancesDomainSelector } from 'modules/redux/selectors/domain'
import { createSelector } from 'reselect'

function getSubTotalCartSelector () {
  return createSelector(
    getInstancesDomainSelector(CART_PRODUCTS_DOMAIN),
    (cartProducts) => {
      return cartProducts.reduce(
        (subTotal, cartProduct) => subTotal + cartProduct.data.price,
        0
      )
    }
  )
}

function getSubTotalPriceCartSelector () {
  return createSelector(
    getSubTotalCartSelector(),
    (subTotal) => {
      return subTotal
    }
  )
}

export {
  getSubTotalCartSelector,
  getSubTotalPriceCartSelector
}
